module.exports = __webpack_public_path__ + "img/gift5.b49a0b7f.png";